
export class StrongoTransportOrder {
    public id:number|null;
    public order_date:Date|null;
    public series:string;
    public oneclick_order_number:number|null;
    public order_reference:string;
    public department_id:number|null;
    public department_code:string|null;
    public cash_on_delivery_ron:number|null;
    public no_need_uit:boolean;
    public fragile:boolean;
    public cnt:number|null;
    public package_id:number|null;
    public package_type:string|null;
    public content:string;
    public loading_address_id:number|null;
    public loading_contact_id:number|null;
    public scheduled_pickup_date:Date|null;
    public from_name:string;
    public from_str:string;
    public from_nr:string;
    public from_bl:string;
    public from_sc:string;
    public from_et:string;
    public from_ap:string;
    public from_interfon:string;
    public from_sector:string;
    public from_city:string;
    public from_county:string;
    public from_zipcode:string;
    public from_country:string;
    public from_phone:string;
    public unloading_address_id:number|null;
    public unloading_contact_id:number|null;
    public scheduled_delivery_date:Date|null;
    public to_str:string;
    public to_nr:string;
    public to_bl:string;
    public to_sc:string;
    public to_et:string;
    public to_ap:string;
    public to_interfon:string;
    public to_sector:string;
    public to_city:string;
    public to_county:string;
    public to_zipcode:string;
    public to_country:string;
    public to_phone:string;
    public to_extra:string;
    public comments:string;

    constructor(data:StrongoTransportOrderData|void) {
        if(data === undefined)
        {
            this.id = null;
            this.order_date = null;
            this.series = "";
            this.oneclick_order_number = null;
            this.order_reference = "";
            this.department_id = null;
            this.department_code = null;
            this.cash_on_delivery_ron = null;
            this.no_need_uit = false;
            this.fragile = false;
            this.cnt = null;
            this.package_id = null;
            this.package_type = null;
            this.content = "";
            this.loading_address_id = null;
            this.loading_contact_id = null;
            this.scheduled_pickup_date = null;
            this.from_name = "";
            this.from_str = "";
            this.from_nr = "";
            this.from_bl = "";
            this.from_sc = "";
            this.from_et = "";
            this.from_ap = "";
            this.from_interfon = "";
            this.from_sector = "";
            this.from_city = "";
            this.from_county = "";
            this.from_zipcode = "";
            this.from_country = "";
            this.from_phone = "";
            this.unloading_address_id = null;
            this.unloading_contact_id = null;
            this.scheduled_delivery_date = null;
            this.to_str = "";
            this.to_nr = "";
            this.to_bl = "";
            this.to_sc = "";
            this.to_et = "";
            this.to_ap = "";
            this.to_interfon = "";
            this.to_sector = "";
            this.to_city = "";
            this.to_county = "";
            this.to_zipcode = "";
            this.to_country = "";
            this.to_phone = "";
            this.to_extra = "";
            this.comments = "";
        }
        else
        {
            this.id = data.id;
            this.order_date = data.order_date;
            this.series = data.series;
            this.oneclick_order_number = data.oneclick_order_number;
            this.order_reference = data.order_reference;
            this.department_id = data.department_id;
            this.department_code = data.department_code;
            this.cash_on_delivery_ron = data.cash_on_delivery_ron;
            this.no_need_uit = data.no_need_uit;
            this.fragile = data.fragile;
            this.cnt = data.cnt;
            this.package_id = data.package_id;
            this.package_type = data.package_type;
            this.content = data.content;
            this.loading_address_id = data.loading_address_id;
            this.loading_contact_id = data.loading_contact_id;
            this.scheduled_pickup_date = data.scheduled_pickup_date;
            this.from_name = data.from_name;
            this.from_str = data.from_str;
            this.from_nr = data.from_nr;
            this.from_bl = data.from_bl;
            this.from_sc = data.from_sc;
            this.from_et = data.from_et;
            this.from_ap = data.from_ap;
            this.from_interfon = data.from_interfon;
            this.from_sector = data.from_sector;
            this.from_city = data.from_city;
            this.from_county = data.from_county;
            this.from_zipcode = data.from_zipcode;
            this.from_country = data.from_country;
            this.from_phone = data.from_phone;
            this.unloading_address_id = data.unloading_address_id;
            this.unloading_contact_id = data.unloading_contact_id;
            this.scheduled_delivery_date = data.scheduled_delivery_date;
            this.to_str = data.to_str;
            this.to_nr = data.to_nr;
            this.to_bl = data.to_bl;
            this.to_sc = data.to_sc;
            this.to_et = data.to_et;
            this.to_ap = data.to_ap;
            this.to_interfon = data.to_interfon;
            this.to_sector = data.to_sector;
            this.to_city = data.to_city;
            this.to_county = data.to_county;
            this.to_zipcode = data.to_zipcode;
            this.to_country = data.to_country;
            this.to_phone = data.to_phone;
            this.to_extra = data.to_extra;
            this.comments = data.comments;
        }
    }
}

export type StrongoTransportOrderData = {
    id:number|null;
    order_date:Date|null;
    series:string;
    oneclick_order_number:number|null;
    order_reference:string;
    department_id:number|null;
    department_code:string|null;
    cash_on_delivery_ron:number|null;
    no_need_uit:boolean;
    fragile:boolean;
    cnt:number|null;
    package_id:number|null;
    package_type:string|null;
    content:string;
    loading_address_id:number|null;
    loading_contact_id:number|null;
    scheduled_pickup_date:Date|null;
    from_name:string;
    from_str:string;
    from_nr:string;
    from_bl:string;
    from_sc:string;
    from_et:string;
    from_ap:string;
    from_interfon:string;
    from_sector:string;
    from_city:string;
    from_county:string;
    from_zipcode:string;
    from_country:string;
    from_phone:string;
    unloading_address_id:number|null;
    unloading_contact_id:number|null;
    scheduled_delivery_date:Date|null;
    to_str:string;
    to_nr:string;
    to_bl:string;
    to_sc:string;
    to_et:string;
    to_ap:string;
    to_interfon:string;
    to_sector:string;
    to_city:string;
    to_county:string;
    to_zipcode:string;
    to_country:string;
    to_phone:string;
    to_extra:string;
    comments:string;
}
